import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import userContext from "../../context/UserContext";
// 1) Import the new CSS file
import "./StoreCard.css";

export const StoreCard = ({ book }) => {
  const { user, setUser } = useContext(userContext);

  const addToCart = () => {
    let available = false;

    user.cartItems.forEach((eachcart) => {
      if (eachcart._id === book._id) {
        available = true;
      }
    });

    if (!available) {
      setUser({
        ...user,
        asideActive: true,
        cartItems: [...user.cartItems, { ...book, quantity: 1 }],
      });
    } else {
      setUser({
        ...user,
        asideActive: true,
      });
    }
  };

  useEffect(() => {
    let price = 0;
    user.cartItems.forEach((item) => {
      price += item.discountedPrice * item.quantity;
    });

    setUser({
      ...user,
      price: price,
    });
    // eslint-disable-next-line
  }, [user]);

  return (
    <div className="store-card">
      <Link to={`/book/${book._id}`} className="store-card-media">
  <img src={book.image} alt={book.bookname} loading="lazy" />
</Link>

      <div className="store-card-content">
        <h1 className="store-card-title">{book.bookname}</h1>

        <p className="store-card-price">
          {book.bookprice !== book.discountedPrice && (
            <strike className="original-price">{book.bookprice} Kr</strike>
          )}
          {book.discountedPrice} Kr
        </p>

        <button className="store-card-add-btn" onClick={addToCart}>
          Lägg till i kundvagn
        </button>
      </div>
    </div>
  );
};
